export class FilteredItems {
  elements = {
    root: null,
    searchBox: null,
    items: [],
  };

  data = {
    meta: [],
  }

  state = {
    metadataByItemElement: new Map(),
  }

  constructor(element) {
    if (!element) {
      return;
    }

    this.elements = {
      root: element,
      searchBox: element.querySelector('.search-box'),
      items: element.querySelectorAll('.items > *'),
    };
    this.data.meta = JSON.parse(this.elements.root.dataset.meta);

    this.buildState();
    this.addEventListeners();
  }

  buildState() {
    for (const [index, data] of this.data.meta.entries()) {
      const element = this.elements.items[index];
      this.state.metadataByItemElement.set(element, data);
    }

    // for (const [element, index] of this.elements.items.entries()) {
      // this.state.metadataByItemElement.set(item)
      // console.log(element, index);
    // }
    // this.state.metadataByItemElement
  }

  addEventListeners() {
    this.elements.searchBox.addEventListener('input', (event) => {
      this.filter({
        searchText: event.target.value,
      });
    });
  }

  filter({ searchText }) {
    for (const [element, metadata] of this.state.metadataByItemElement.entries()) {
      element.classList.remove('hidden');

      if (!metadata.text.toLowerCase().includes(searchText.toLowerCase())) {
        element.classList.add('hidden');
      }
    }
  }
}
